var productImagesSlider = null;
var galleryThumbs = null;
var slidesCount = null;
jQuery(document).ready(function ($) {

    $('img').prop('draggable', false);

    var menuHoverTimeout = null;
    $('#menu-aside ul.menu > li.menu-item--has-dropdown:not(.menu-item--active)')
        .on('mouseenter', function () {
            if ($(window).width() <= 950) return;
            if (!$('body').hasClass('template-index')){
                let topPos = $(this).offset().top - window.pageYOffset;
                if ($(window).height() < 850){
                    topPos = topPos - $('> ul', this).height() / 2;
                }
                $('> ul', this).css({
                    top: topPos
                });
            }
            $(document.body).addClass('overlayed');
            if (menuHoverTimeout) clearTimeout(menuHoverTimeout);
        })
        .on('mouseleave', function () {
            if ($(window).width() <= 950) return;
            menuHoverTimeout = setTimeout(() => {
                $(document.body).removeClass('overlayed')
            }, 100)
        });


    $('#menu-aside ul.menu > li.menu-item--has-dropdown > a').on('click', function (e) {
        if ($(window).width() > 950) return true;
        let _self = this;
        e.preventDefault();
        $('#menu-aside ul.menu > li.menu-item--has-dropdown').each(function () {
            if ($('> a', this).is(_self)) {
                return
            }
            $(this).removeClass('expanded').find('> ul').slideUp();
        })

        $(this).parent().toggleClass('expanded').find('> ul').stop(1, 1).slideToggle();
    })

    if ($('.hero-section .site-logo').length) {
        var distance = $('.hero-section .site-logo').offset().top + $('.hero-section .site-logo').height();

        $(window).scroll(function () {
            if ($(window).scrollTop() >= distance) {
                $('#header .logo').addClass('scrolled');
            } else {
                $('#header .logo').removeClass('scrolled');
            }
        });
    }

    $('#menu-toggle').on('click', function () {
        $('#menu-aside, #overlay, main').toggleClass('opened');
    })

    $('#overlay, #menu-close').on('click', function () {
        $('#menu-aside, #overlay, main').toggleClass('opened');
    })


    $(document).on('click', '.infinitpagin a.loadMore', function (e) {
        e.preventDefault();
        let _self = $(this);
        if ($('body').hasClass('loading')) return false;
        if (_self.hasClass('loading')) return false;
        const moreURL = _self.attr('href');
        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: moreURL,
            beforeSend: function () {
                $('body').addClass('loading');
                _self.addClass('loading');
            },
            complete: function (data) {
                $('.items-list').append($(".items-list", data.responseText).html());

                if ($(".infinitpagin", data.responseText).html()) {
                    $('.infinitpagin').html($(".infinitpagin", data.responseText).html());
                } else {
                    $('.infinitpagin').remove();
                }

                $('body').removeClass('loading');
                _self.removeClass('loading');
            }
        });
    });

    $(document)
        .on('mouseenter', '.product-item .extra-images span', function () {
            let idx = $(this).attr('data-idx');
            let productItem = $(this).parents('.product-item');
            $(`.extra-images-full span[data-idx="${idx}"]`, productItem[0]).addClass('visible');
        })
        .on('mouseleave', '.product-item .extra-images span', function () {
            let idx = $(this).attr('data-idx');
            let productItem = $(this).parents('.product-item');
            $(`.extra-images-full span[data-idx="${idx}"]`, productItem[0]).removeClass('visible');
        })

    if ($(window).width() <= 750) {
        $('.extra-images-full, .extra-images').remove();
    }

    $('#Collection .mobile-header .collection-menu-toggle.expandable').on('click', function () {
        $(this).toggleClass('expanded').next('.sub-collections').stop(1, 1).slideToggle();
        $('.collection-page-content').toggleClass('overlayed');
    });

    if ($('select.single-option-selectoraa').length) {
        $('select.single-option-selector').each(function () {
            new SlimSelect({
                select: this,
                placeholder: $(this).attr('data-placeholder'),
                showSearch: false,
                onChange: (info) => {
                    console.log(info)
                }
            })
        })
    }

    if ($('.product-single__photo:not(.hide)').length) {
        let $newImage = $('.product-single__photo:not(.hide)');

        if ($(window).width() <= 850) {
            let scrolledPos = $('.images-holder > div').scrollLeft();
            $('.images-holder > div').animate({'scrollLeft': scrolledPos + $newImage.position().left}, 300);
        }
    }

    $.fn.shuffle = function () {

        var allElems = this.get(),
            getRandom = function (max) {
                return Math.floor(Math.random() * max);
            },
            shuffled = $.map(allElems, function () {
                var random = getRandom(allElems.length),
                    randEl = $(allElems[random]).clone(true)[0];
                allElems.splice(random, 1);
                return randEl;
            });

        this.each(function (i) {
            $(this).replaceWith($(shuffled[i]));
        });

        return $(shuffled);

    };

    $('.product-tabs .tabs-list li').on('click', function () {
        if ($(this).hasClass('active')) return false;

        let $container = $(this).parents('.product-tabs');
        let targetTab = $(this).attr('data-tab');

        $(this).addClass('active').siblings('li').removeClass('active');
        $(`${targetTab}.tab`).addClass('active').siblings('.tab').removeClass('active');
    });

    $('.product-tabs .tab .tab-title').on('click', function () {
        let currentTab = $(this).parents('.tab');
        let currentTabContent = $(this).next('div');

        let othertabs = currentTab.siblings('.tab');
        othertabs.removeClass('active').find('div').slideUp();

        currentTab.toggleClass('active');
        currentTabContent.stop(1,1).slideToggle();
    })

    $('#shopify-section-product-template .product-form').on('submit', function (e) {
        e.preventDefault();

        let _this = $(this)
        let submitBtn = _this.find('button.product-form__cart-submit');

        if ($(this).hasClass('loading') || submitBtn.is('[disabled]')) {
            return false;
        }

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: _this.serialize(),
            dataType: 'json',
            beforeSend: function () {
                _this.addClass('loading').find('button.product-form__cart-submit').addClass('loading');
            },
            error: function () {
                alert('Error! Please Try again!');
                _this.removeClass('loading').find('button.product-form__cart-submit').removeClass('loading');
            },
            success: function () {
                _this.find('button.product-form__cart-submit').removeClass('loading').addClass('added');
                $.ajax({
                    url: '/cart.js',
                    success: function (data) {
                        $('.cart-indicator .cart-count').text(data.item_count)
                    },
                    dataType: 'json'
                });
                setTimeout(function () {
                    _this.removeClass('loading').find('button.product-form__cart-submit').removeClass('added');
                }, 1500);
            },
            cache: false
        });
    })

    if ($('[data-fancybox="gallery"]').length) {
        $('[data-fancybox="gallery"]').fancybox({
            buttons: [
                "zoom",
                "fullScreen",
                "close"
            ],
        });
    }

    $('.images-holder .arrow').click(function () {
        let container = $(this).siblings('div');

        if (container.hasClass('scrolling')) {
            return false;
        }
        let scrolledPos = container.scrollLeft();
        let visibleElement = $('.product-single__photo-wrapper.active', container[0]).last();
        let nextElement = visibleElement.next('.product-single__photo-wrapper');
        if (!nextElement.length) {
            $('.product-single__photo-wrapper', container[0]).removeClass('active');
            nextElement = $('.product-single__photo-wrapper', container[0]).first();
            scrolledPos = 0;
        }

        let toScroll = scrolledPos + nextElement.position().left

        container.addClass('scrolling').stop(true, true).animate({'scrollLeft': toScroll}, 300, function () {
            container.removeClass('scrolling');
            nextElement.addClass('active');
        });
    })

    if ($('.product-holder .images-holder').length && $('.product-holder .images-holder .swiper-slide').length > 1) {
slidesCount = $('.product-holder .images-holder .swiper-slide').length;
        let isDesktop = null;

        let swiperOptions = {
            on: {
                init: function () {
                    var slideIdx = null;
                    this.slideTo(0)
                    this.slides.each(function (idx) {
                        if ($(".product-single__photo:not(.hide)", this).length) {
                            slideIdx = idx;
                            return false;
                        }
                    });
                    this.slideTo(slideIdx)
                    $('.slides-count .total').text(this.slides.length)
                    $('.slides-count .current').text(slideIdx +1)
                },
                slideChange: function () {
                    console.log('aaa')
                    $('.slides-count .current').text(this.realIndex +1)
                }
            }
        }

        if ($(window).width() > 850) {
            galleryThumbs = new Swiper('.slider-thumbs', {
                spaceBetween: 10,
                slidesPerView: 'auto',
                loop: false,
                freeMode: true,
                loopedSlides: slidesCount, //looped slides should be the same
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
/*                navigation: {
                    prevEl: '.slider-arrow.arrow-left',
                    nextEl: '.slider-arrow.arrow-right',
                },*/
                on: {
                    init: function () {
                        $('.slider-arrow').addClass('vis');
                    }
                }
            });

            swiperOptions.slidesPerView = 1;
            swiperOptions.spaceBetween = 20;
            swiperOptions.loop = true;
            swiperOptions.loopedSlides = slidesCount;
            swiperOptions.thumbs = {
                swiper: galleryThumbs
            };
/*            swiperOptions.navigation = {
                prevEl: '.slider-arrow.arrow-left',
                nextEl: '.slider-arrow.arrow-right',
            };*/
            isDesktop = true;

        }
        else {
            swiperOptions.spaceBetween= 35;
            swiperOptions.freeMode= true;
            swiperOptions.watchOverflow= true;
            swiperOptions.slidesPerView= 'auto';
            isDesktop = false;
            swiperOptions.navigation = {
                nextEl: '.images-holder span.arrow',
            };
        }
        productImagesSlider = new Swiper('.product-holder .images-holder', swiperOptions);

        $(window).resize(function () {
            let wWidth = $(window).width();
            if (wWidth > 850 && isDesktop === false){
                isDesktop = true;
                let swiperOptions = {
                    on: {
                        init: function () {
                            console.log(this)
                            var slideIdx = null;
                            this.slides.each(function (idx) {
                                if ($(".product-single__photo:not(.hide)", this).length) {
                                    slideIdx = idx;
                                    return false;
                                }
                                $('.slider-arrow').addClass('vis');
                                $('.slides-count .total').text(this.slides.length)
                                $('.slides-count .current').text(slideIdx +1)
                            });
                            this.slideTo(slideIdx)
                        },
                        slideChange: function () {
                            console.log('aaa')
                            $('.slides-count .current').text(this.realIndex +1)
                        }
                    }
                }

                productImagesSlider.destroy();
                galleryThumbs.destroy();
                productImagesSlider = null;
                galleryThumbs = null;
                galleryThumbs = new Swiper('.slider-thumbs', {
                    spaceBetween: 10,
                    slidesPerView: 'auto',
                    loop: false,
                    freeMode: true,
                    loopedSlides: slidesCount, //looped slides should be the same
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    /*                navigation: {
                                        prevEl: '.slider-arrow.arrow-left',
                                        nextEl: '.slider-arrow.arrow-right',
                                    },*/
                    on: {
                        init: function () {
                            $('.slider-arrow').addClass('vis');
                        }
                    }
                });

                swiperOptions.slidesPerView = 1;
                swiperOptions.spaceBetween = 20;
                swiperOptions.loop = true;
                // swiperOptions.navigation = {
                //     prevEl: '.slider-arrow.arrow-left',
                //     nextEl: '.slider-arrow.arrow-right',
                // };
                swiperOptions.loopedSlides = slidesCount;
                swiperOptions.thumbs = {
                    swiper: galleryThumbs
                };

                productImagesSlider = new Swiper('.product-holder .images-holder', swiperOptions);
                productImagesSlider.update();
            }
            else if(wWidth <= 850 && isDesktop === true){
                isDesktop = false;
                let swiperOptions = {
                    on: {
                        init: function () {
                            console.log(this)
                            var slideIdx = null;
                            this.slides.each(function (idx) {
                                if ($(".product-single__photo:not(.hide)", this).length) {
                                    slideIdx = idx;
                                    return false;
                                }
                                $('.slider-arrow').addClass('vis');
                            });
                            this.slideTo(slideIdx)
                            $('.slides-count .current').text(this.realIndex +1)
                            $('.slides-count .total').text(this.slides.length)
                        },
                        slideChange: function () {
                            console.log('aaa')
                            $('.slides-count .current').text(this.realIndex +1)
                        }
                    }
                }
                swiperOptions.spaceBetween= 35;
                swiperOptions.freeMode= true;
                swiperOptions.watchOverflow= true;
                swiperOptions.slidesPerView= 'auto';
                swiperOptions.navigation = {
                    nextEl: '.images-holder span.arrow',
                };
                productImagesSlider.destroy();
                productImagesSlider = null;
                productImagesSlider = new Swiper('.product-holder .images-holder', swiperOptions);
                productImagesSlider.update();
            }
        })


    }

    if ($('#shopify-section-product-template').length) {
        let relatedProducts = $('.related .products-grid .product-item');

        if (relatedProducts.length) {
            if (relatedProducts.length > 4) {
                relatedProducts.shuffle();
            }
            $('.related .products-grid .product-item').slice(4).remove();
            $('.related .products-grid .product-item').addClass('vis');
        }

        $('.slider-arrow.arrow-left').on('click', function () {
            productImagesSlider.slidePrev()
        })
        $('.slider-arrow.arrow-right').on('click', function () {
            productImagesSlider.slideNext()
        })

    }

});